<script setup>
import { computed } from 'vue'
import { usePortAllData } from '@/stores/portAllData';
import { storeToRefs } from 'pinia';
import { LIGHT_CONDITION } from '@/plugins/utils/constantes';
import logo_day from '@/assets/images/portall-logo_DAY.png';
import logo_dusk from '@/assets/images/portall-logo_DUSK.png';
import logo_night from '@/assets/images/portall-logo_NIGHT.png';
import logo_day_mobile from '@/assets/images/portall-logo_DAY_mobile.png';
import logo_dusk_mobile from '@/assets/images/portall-logo_DUSK_mobile.png';
import logo_night_mobile from '@/assets/images/portall-logo_NIGHT_mobile.png';

const store = usePortAllData();

const { getLayerColor, getIsMobile } = storeToRefs(store);

const geomod_url = 'https://www.geomod.fr/savoir_faire/geomatique-marine';

const logoPath = computed(() => {
  if (getIsMobile.value) {
    if (getLayerColor.value === LIGHT_CONDITION.DAY) return logo_day_mobile
    else if (getLayerColor.value === LIGHT_CONDITION.DUSK) return logo_dusk_mobile
    else if (getLayerColor.value === LIGHT_CONDITION.NIGHT) return logo_night_mobile
  } else {
    if (getLayerColor.value === LIGHT_CONDITION.DAY) return logo_day
    else if (getLayerColor.value === LIGHT_CONDITION.DUSK) return logo_dusk
    else if (getLayerColor.value === LIGHT_CONDITION.NIGHT) return logo_night
  }
  return logo_day
})
</script>

<template>
  <div class="geomod-logo">
    <a :href="geomod_url" target="_blank">
      <img :src="logoPath" alt="PortAll logo">
    </a>
  </div>
</template>